import { DriveStep } from "driver.js";

import { getCommonFinalSteps } from "./commonSteps";

/**
 * Overview tab tour - highlights tabs, filters, and data availability heatmap.
 */
export const getDataPageOverviewTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="data-tabs"]',
    popover: {
      title: t("tour.dataPage.tabs.title"),
      description: t("tour.dataPage.tabs.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="data-filters"]',
    popover: {
      title: t("tour.dataPage.filters.title"),
      description: t("tour.dataPage.filters.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="data-entity-status"]',
    popover: {
      title: t("tour.dataPage.entityStatus.title"),
      description: t("tour.dataPage.entityStatus.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const dataPageOverviewTourConfig = {
  id: "dataPageOverview" as const,
  steps: getDataPageOverviewTourSteps,
};

/**
 * Files tab tour - highlights file table with search and status filters.
 */
export const getDataPageFilesTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="data-files-table"]',
    popover: {
      title: t("tour.dataPage.filesTable.title"),
      description: t("tour.dataPage.filesTable.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const dataPageFilesTourConfig = {
  id: "dataPageFiles" as const,
  steps: getDataPageFilesTourSteps,
};

/**
 * Review tab tour - highlights entity tabs and editable data table.
 */
export const getDataPageReviewTourSteps = (
  t: (key: string) => string
): DriveStep[] => [
  {
    element: '[data-tour="data-review-entity-tabs"]',
    popover: {
      title: t("tour.dataPage.reviewEntityTabs.title"),
      description: t("tour.dataPage.reviewEntityTabs.description"),
      side: "bottom",
      align: "start",
    },
  },
  {
    element: '[data-tour="data-review-farm-section"]',
    popover: {
      title: t("tour.dataPage.reviewFarmSection.title"),
      description: t("tour.dataPage.reviewFarmSection.description"),
      side: "top",
      align: "start",
    },
  },
  ...getCommonFinalSteps(t),
];

export const dataPageReviewTourConfig = {
  id: "dataPageReview" as const,
  steps: getDataPageReviewTourSteps,
};
